import ReactDOM from "react-dom";

const PortalHead = (props) => {
  const headRoot = document.head;

  return ReactDOM.createPortal(props.children, headRoot);
};

export default PortalHead;
